(function () {
  const $ = (s) => document.querySelector(s);
  const cfg = () => window.__cartDrawerSettings || {};
  const postJSON = (url, data) =>
    fetch(url, { ...fetchConfig(), body: JSON.stringify(data) });
  // Every cart attribute we own goes through here. Passing '' removes one.
  const updateCartAttrs = (attributes) => postJSON('/cart/update.js', { attributes });

  const MONTHS = ['Januar','Februar','Marts','April','Maj','Juni','Juli','August','September','Oktober','November','December'];
  const WEEKDAYS = ['Ma','Ti','On','To','Fr','Lø','Sø'];

  // Pure date/method logic lives in cart-drawer-logic.js (loaded first) so it
  // can be unit-tested. These thin wrappers bind it to the live theme settings
  // and the currently selected method, keeping the callers below unchanged.
  const L = window.CartDrawerLogic;
  // Degrade gracefully if the logic module failed to load (e.g. a partial
  // deploy) rather than throwing and taking every cart feature down with it.
  if (!L) return;
  const serverNow = () => { const iso = cfg().todayIso; return iso ? new Date(iso + 'T00:00:00') : new Date(); };
  const isoDate = L.isoDate;
  const dateRange = () => L.dateRange(cfg(), serverNow());
  const firstSelectableMonth = () => L.firstSelectableMonth(getMethod(), cfg(), serverNow());
  const methodLabel = (method) => L.methodLabelFor(method, cfg());

  // Abbreviated ("man. 3. aug. 2026") because the field shares its row with the
  // pickup time — the long form ("mandag den 3. august 2026") overflows at half
  // width. Only the input display is shortened; the cart still stores the ISO date.
  function formatDate(d) {
    return d.toLocaleDateString('da-DK', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
  }

  /* ── Delivery method ──────────────────────────────────────── */

  // Source of truth: data-method on the selector (rendered by Liquid from
  // the cart attribute). Falls back to 'shipping' when the selector is absent.
  function getMethod() {
    const wrap = $('.cart-drawer__methods');
    return wrap && wrap.dataset.method === 'pickup' ? 'pickup' : 'shipping';
  }

  // A product tagged "ej levering" in the cart locks delivery to pickup. Liquid
  // computes this per cart render (data-delivery-blocked); we only read it here.
  function isDeliveryBlocked() {
    const wrap = $('.cart-drawer__methods');
    return !!wrap && wrap.dataset.deliveryBlocked === 'true';
  }

  // When delivery is blocked, Liquid already renders the selector as pickup and
  // disables the home button, so getMethod()/syncPackaging() below treat the
  // cart as pickup automatically. This just persists that correction to the
  // cart attribute (once per render — guarded by data-block-enforced) so the
  // stored method / order reflects pickup even if it was previously "home".
  function enforceDeliveryBlock() {
    const wrap = $('.cart-drawer__methods');
    if (!wrap || wrap.dataset.deliveryBlocked !== 'true') return;
    if (wrap.dataset.blockEnforced) return;
    wrap.dataset.blockEnforced = '1';
    updateCartAttrs({ Leveringsmetode: methodLabel('pickup'), Leveringsmetode_key: 'pickup' });
  }

  /* ── Calendar ─────────────────────────────────────────────── */

  function el(tag, props) { return Object.assign(document.createElement(tag), props); }

  function disableNav(btn) {
    btn.disabled = true;
    btn.classList.add('cdp-calendar__nav--disabled');
  }

  function buildCalendar(year, month, onSelect, selectedIso) {
    const range = dateRange();
    const method = getMethod();
    const settings = cfg();
    const wrap = el('div', { className: 'cdp-calendar' });

    const prev = el('button', { type: 'button', textContent: '‹', className: 'cdp-calendar__nav' });
    const next = el('button', { type: 'button', textContent: '›', className: 'cdp-calendar__nav' });
    const title = el('span', { textContent: `${MONTHS[month]} ${year}` });
    const header = el('div', { className: 'cdp-calendar__header' });
    header.append(prev, title, next);
    wrap.append(header);

    const grid = el('div', { className: 'cdp-calendar__grid' });
    WEEKDAYS.forEach(label => grid.append(el('div', { className: 'cdp-calendar__dow', textContent: label })));

    const firstDow = new Date(year, month, 1).getDay();
    const offset = firstDow === 0 ? 6 : firstDow - 1;
    for (let i = 0; i < offset; i++) grid.append(el('div', { textContent: ' ' }));

    const daysInMonth = new Date(year, month + 1, 0).getDate();
    for (let d = 1; d <= daysInMonth; d++) {
      const date = new Date(year, month, d);
      const cell = el('button', { type: 'button', textContent: d, className: 'cdp-calendar__day' });
      if (L.isSelectable(date, method, settings, range)) {
        if (isoDate(date) === selectedIso) cell.classList.add('cdp-calendar__day--selected');
        cell.addEventListener('click', () => onSelect(date));
      } else {
        cell.disabled = true;
        cell.classList.add('cdp-calendar__day--disabled');
      }
      grid.append(cell);
    }
    wrap.append(grid);

    const thisMonth = new Date(year, month, 1);
    const earliestMonth = new Date(range.earliest.getFullYear(), range.earliest.getMonth(), 1);
    if (thisMonth <= earliestMonth) disableNav(prev);
    if (new Date(year, month + 1, 1) > range.latest) disableNav(next);

    function navigate(dir) {
      const m = (month + dir + 12) % 12;
      const y = year + (month + dir < 0 ? -1 : month + dir > 11 ? 1 : 0);
      wrap.replaceWith(buildCalendar(y, m, onSelect, selectedIso));
    }
    prev.addEventListener('click', (e) => { e.stopPropagation(); if (!prev.disabled) navigate(-1); });
    next.addEventListener('click', (e) => { e.stopPropagation(); if (!next.disabled) navigate(1); });

    return wrap;
  }

  /* ── Datepicker ───────────────────────────────────────────── */

  // Lets the method selector clear a previously chosen date when the set of
  // selectable days changes. Set by initDatepicker, persists with its DOM.
  let resetDatepicker = null;

  function initDatepicker() {
    const input = $('.cart-drawer__date-input');
    const hidden = $('.cart-drawer__delivery-date-value');
    if (!input || !hidden || input.dataset.cdpReady) return;
    input.dataset.cdpReady = '1';

    let popup = null;
    let selectedIso = hidden.value || '';

    // A stored date can go stale between visits — now in the past, newly
    // blocked, beyond the lead-time window, or invalid for the current method.
    // Drop it so the customer must re-pick and checkout re-gates, instead of
    // letting an invalid delivery date ride through to the order.
    if (selectedIso) {
      const stored = new Date(selectedIso + 'T00:00:00');
      if (L.isSelectable(stored, getMethod(), cfg(), dateRange())) {
        input.value = formatDate(stored);
      } else {
        selectedIso = '';
        hidden.value = '';
        const attrs = { Leveringsdato: '' };
        syncPickupTime(attrs);
        updateCartAttrs(attrs);
      }
    }

    function open() {
      if (popup) return;
      const base = selectedIso ? new Date(selectedIso + 'T00:00:00') : firstSelectableMonth();
      popup = el('div', { className: 'cdp-popup' });
      popup.append(buildCalendar(base.getFullYear(), base.getMonth(), (date) => {
        selectedIso = isoDate(date);
        input.value = formatDate(date);
        hidden.value = selectedIso;
        // The offered times depend on the weekday of the chosen date, so the
        // select has to be rebuilt whenever the date changes; a stored time the
        // new day doesn't offer folds its clear into the update below.
        const attrs = { Leveringsdato: selectedIso };
        syncPickupTime(attrs);
        // Persist to the cart so the date survives a page reload or any Dawn
        // drawer re-render (the hidden field alone is otherwise only submitted
        // at checkout). Fire-and-forget — the UI already reflects the choice.
        updateCartAttrs(attrs);
        close();
      }, selectedIso));
      input.parentNode.append(popup);
    }

    function close() {
      popup?.remove();
      popup = null;
    }

    input.addEventListener('click', () => popup ? close() : open());
    document.addEventListener('click', (e) => {
      if (popup && !popup.contains(e.target) && e.target !== input) close();
    });

    resetDatepicker = () => {
      selectedIso = '';
      input.value = '';
      hidden.value = '';
      close();
    };
  }

  /* ── Pickup time ──────────────────────────────────────────── */

  // Rebuilds the time field from pickupTimeState (visibility + options + gate
  // all derive from that one policy). A stored time the selection no longer
  // offers (e.g. 16:00 after switching to a Saturday, or anything at all after
  // switching to home delivery) is dropped and cleared on the cart, so checkout
  // re-gates rather than carrying an impossible slot through to the order.
  // Callers about to update the cart anyway pass their attrs object and the
  // clear folds into it; standalone calls send it as its own request.
  function renderPickupTimes(pendingAttrs) {
    const wrap = $('.cart-drawer__pickup-time');
    const select = wrap?.querySelector('.cart-drawer__time-select');
    const hidden = $('.cart-drawer__pickup-time-value');
    if (!wrap || !select || !hidden) return;

    const iso = $('.cart-drawer__delivery-date-value')?.value || '';
    const state = L.pickupTimeState(getMethod(), iso, cfg());

    if (hidden.value && !state.times.includes(hidden.value)) {
      hidden.value = '';
      if (pendingAttrs) pendingAttrs.Afhentningstid = '';
      else updateCartAttrs({ Afhentningstid: '' });
    }

    wrap.hidden = !state.visible;
    select.replaceChildren(
      el('option', { value: '', textContent: iso ? 'Vælg tidspunkt' : 'Vælg dato først' }),
      ...state.times.map((t) => el('option', { value: t, textContent: t }))
    );
    select.value = hidden.value;
    select.disabled = !state.required;
  }

  // Render + re-gate checkout. Anything that changes the method or the date
  // wants both, so they travel together.
  function syncPickupTime(pendingAttrs) {
    renderPickupTimes(pendingAttrs);
    updateCheckoutButton();
  }

  function initPickupTime() {
    const select = $('.cart-drawer__time-select');
    if (!select || select.dataset.timeReady) return;
    select.dataset.timeReady = '1';
    select.addEventListener('change', () => {
      const hidden = $('.cart-drawer__pickup-time-value');
      if (hidden) hidden.value = select.value;
      updateCartAttrs({ Afhentningstid: select.value });
      updateCheckoutButton();
    });
  }

  /* ── Packaging (auto-add/remove, method-aware) ────────────── */

  // Dawn only refreshes the header cart bubble through its own add/quantity
  // flows; the packaging requests below bypass those, and Dawn's cartUpdate
  // handler re-renders only the drawer's line items + footer. So each packaging
  // request asks the Cart API to render the bubble section too (sections param),
  // and this swaps it in the same way Dawn's own renderContents does.
  function renderCartIconBubble(sections) {
    const html = sections && sections['cart-icon-bubble'];
    const target = document.getElementById('cart-icon-bubble');
    if (!html || !target) return;
    const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (section) target.innerHTML = section.innerHTML;
  }

  // RØNHAVE-TØRVARER: Varer fra disse kollektioner kræver ikke køl. Består kurven KUN af sådanne varer, kommer der ingen thermokasse på.
  const DRY_COLLECTIONS = ['polsemagerens-grundsortiment', 'ronhaveslagteren-diy', 'krydderier', 'krydderiblandinger'];
  let dryIdsPromise = null;
  function getDryProductIds() { if (!dryIdsPromise) dryIdsPromise = Promise.all(DRY_COLLECTIONS.map(h => fetch('/collections/' + h + '/products.json?limit=250').then(r => r.ok ? r.json() : { products: [] }).then(j => (j.products || []).map(p => p.id)).catch(() => []))).then(lists => new Set(lists.flat())); return dryIdsPromise; }
  let pkgBusy = false;
  let lastEventCart = null;

  // Adds the packaging item only for home delivery when the cart holds other
  // items; removes it for pickup or an empty cart. Idempotent — safe to call
  // on every init. Returns true when it changed the cart (and published).
  async function syncPackaging(methodOverride) {
    const container = $('.cart-drawer__packaging[data-packaging-variant]');
    if (!container) return false;
    const variantId = container.dataset.packagingVariant;
    if (!variantId || pkgBusy) return false;
    pkgBusy = true;

    try {
      const method = methodOverride || getMethod();
      const cart = lastEventCart && Array.isArray(lastEventCart.items)
        ? lastEventCart
        : await fetch('/cart.js').then(r => r.json());
      lastEventCart = null;
      const dryIds = await getDryProductIds(); // RØNHAVE-TØRVARER
      const hasOther = cart.items.some(i => String(i.variant_id) !== variantId && i.quantity > 0 && !dryIds.has(i.product_id));
      const pkgItem = cart.items.find(i => String(i.variant_id) === variantId);
      const shouldHave = L.shouldHavePackaging(method, hasOther);

      const sections = 'cart-icon-bubble';
      let res;
      if (shouldHave && !pkgItem) {
        res = await postJSON('/cart/add.js', { id: variantId, quantity: 1, sections });
      } else if (shouldHave && pkgItem && pkgItem.quantity !== 1) {
        res = await postJSON('/cart/change.js', { id: variantId, quantity: 1, sections });
      } else if (!shouldHave && pkgItem) {
        res = await postJSON('/cart/change.js', { id: variantId, quantity: 0, sections });
      } else {
        return false;
      }
      // Bail on failure (e.g. packaging sold out) instead of publishing a
      // cartUpdate — that would re-enter init() → syncPackaging() and retry
      // the same failing request on a loop.
      if (!res.ok) return false;
      renderCartIconBubble((await res.json()).sections);
      if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'custom-packaging' });
      return true;
    } finally {
      pkgBusy = false;
    }
  }

  /* ── Method selector ──────────────────────────────────────── */

  let methodBusy = false;

  async function setMethod(method) {
    const wrap = $('.cart-drawer__methods');
    if (!wrap || methodBusy || pkgBusy) return;
    // Delivery is locked while an "ej levering" product is in the cart — ignore
    // any attempt to switch back to shipping (the button is also disabled in Liquid).
    if (method === 'shipping' && isDeliveryBlocked()) return;
    if (method === getMethod()) return;
    methodBusy = true;
    const label = methodLabel(method);

    try {
      // Update the selector in place. A publish()-driven cartUpdate only
      // re-renders the line items + subtotals (not this block), so these
      // optimistic updates survive it; the choice is also persisted below, so a
      // full drawer re-render (e.g. add-to-cart) restores it from the cart.
      wrap.dataset.method = method;
      wrap.querySelectorAll('[data-method-value]').forEach((b) => {
        const on = b.dataset.methodValue === method;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      const hiddenMethod = $('.cart-drawer__method-value');
      if (hiddenMethod) hiddenMethod.value = label;
      const hiddenKey = $('.cart-drawer__method-key');
      if (hiddenKey) hiddenKey.value = method;

      // Clear any previously picked date — selectable days differ per method —
      // and rebuild the time field; a stored time the new method doesn't offer
      // folds its clear into the update below.
      if (resetDatepicker) resetDatepicker();
      const attrs = { Leveringsmetode: label, Leveringsmetode_key: method, Leveringsdato: '' };
      syncPickupTime(attrs);

      // Persist the choice to the cart so it reaches checkout / the order and
      // can drive delivery rules.
      await updateCartAttrs(attrs);

      // Add packaging for home delivery, remove it for pickup. This publishes
      // a cartUpdate that re-renders the line items + subtotals.
      await syncPackaging(method);
    } catch (e) {
      // Network failure mid-switch: the optimistic UI may be ahead of the cart.
      // Re-run init on the next drawer open/cartUpdate reconciles it; avoid an
      // unhandled rejection here.
      console.warn('[cart-drawer] setMethod failed', e);
    } finally {
      methodBusy = false;
    }
  }

  function initMethods() {
    const wrap = $('.cart-drawer__methods');
    if (!wrap || wrap.dataset.methodsReady) return;
    wrap.dataset.methodsReady = '1';
    wrap.querySelectorAll('[data-method-value]').forEach((btn) => {
      btn.addEventListener('click', () => setMethod(btn.dataset.methodValue));
    });
  }

  /* ── Terms & checkout gating ──────────────────────────────── */

  function updateCheckoutButton() {
    const btn = $('#CartDrawer-Checkout');
    if (!btn) return;
    const { termsEnabled, dateEnabled } = cfg();
    const termsOk = !termsEnabled || !!$('.cart-drawer__terms-checkbox')?.checked;
    const dateIso = $('.cart-drawer__delivery-date-value')?.value || '';
    const dateOk = !dateEnabled || !!dateIso;
    // Liquid nests the time field inside the date picker and method selector, so
    // its presence — not a setting — is what says the customer can act on it.
    // When a time is actually required is pickupTimeState's call (logic module).
    const timeField = $('.cart-drawer__pickup-time-value');
    const timeOk = !timeField
      || !L.pickupTimeState(getMethod(), dateIso, cfg()).required
      || !!timeField.value;
    btn.disabled = !(termsOk && dateOk && timeOk);
  }

  function initTerms() {
    const cb = $('.cart-drawer__terms-checkbox');
    if (!cb || cb.dataset.termsReady) return;
    cb.dataset.termsReady = '1';
    cb.addEventListener('change', updateCheckoutButton);
  }

  /* ── Bootstrap ────────────────────────────────────────────── */

  // On the standalone /cart page, route the page's own checkout button through
  // the gated drawer instead of letting it submit straight to checkout.
  function initCartPageFunnel() {
    if (!document.querySelector('cart-items')) return; // only the /cart page renders <cart-items>
    const drawer = document.querySelector('cart-drawer');
    const pageCheckout = document.querySelector('#checkout');
    if (!drawer || !pageCheckout || pageCheckout.dataset.funnelReady) return;
    pageCheckout.dataset.funnelReady = '1';
    pageCheckout.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (typeof drawer.open === 'function') drawer.open();
    }, true);
  }

  function init() {
    initMethods();
    enforceDeliveryBlock();
    initDatepicker();
    initPickupTime();
    renderPickupTimes();
    syncPackaging();
    initTerms();
    updateCheckoutButton();
  }

  let initTimer = null;
  function scheduleInit() {
    clearTimeout(initTimer);
    initTimer = setTimeout(init, 50);
  }

  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.cartData && Array.isArray(event.cartData.items)) lastEventCart = event.cartData;
      scheduleInit();
    });
  }

  customElements.whenDefined('cart-drawer').then(() => {
    const proto = customElements.get('cart-drawer').prototype;
    const origOpen = proto.open;
    proto.open = function (...args) {
      origOpen.apply(this, args);
      scheduleInit();
    };
  });

  function boot() {
    initCartPageFunnel();
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

// RØNHAVE-TILPASNING: Minimum 4 stk. på "Tapasanretning – minimum 4 kuverter".
// Antal-feltet starter på 4, minus stopper ved 4, og kurven kan ikke komme under 4
// (fjern-knappen virker stadig). Tilføj flere varianter/produkter i listerne herunder.
(function () {
  const MIN_QTY = 4;
  const MIN_VARIANT_IDS = ['56497730552191'];
  const MIN_PRODUCT_URLS = ['/products/tapas-anretning-mere-festlig'];

  function isMinProductInput(input) {
    const qi = input.closest('quantity-input');
    const url = (qi && qi.dataset.url) || '';
    return MIN_PRODUCT_URLS.some(function (u) { return url.indexOf(u) !== -1; });
  }

  function applyMinQty() {
    document.querySelectorAll('input.quantity__input').forEach(function (input) {
      const isProduct = isMinProductInput(input);
      const isCartLine = MIN_VARIANT_IDS.indexOf(String(input.dataset.quantityVariantId)) !== -1;
      if (!isProduct && !isCartLine) return;
      if (String(input.min) !== String(MIN_QTY)) input.min = MIN_QTY;
      if (input.dataset.min !== String(MIN_QTY)) input.dataset.min = MIN_QTY;
      if (isProduct && (parseInt(input.value, 10) || 0) < MIN_QTY) input.value = MIN_QTY;
      const qi = input.closest('quantity-input');
      const minus = qi && qi.querySelector('.quantity__button[name="minus"]');
      if (minus) minus.classList.toggle('disabled', (parseInt(input.value, 10) || 0) <= MIN_QTY);
    });
  }

  let minQtyBusy = false;
  async function enforceCartMin() {
    if (minQtyBusy) return;
    minQtyBusy = true;
    try {
      const cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      const low = (cart.items || []).filter(function (i) {
        return MIN_VARIANT_IDS.indexOf(String(i.variant_id)) !== -1 && i.quantity > 0 && i.quantity < MIN_QTY;
      });
      if (!low.length) return;
      for (const item of low) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: MIN_QTY })
        });
      }
      window.location.reload();
    } catch (e) {
      console.warn('Min. antal kunne ikke tjekkes', e);
    } finally {
      minQtyBusy = false;
    }
  }

  let minQtyTimer = null;
  function scheduleApply() {
    clearTimeout(minQtyTimer);
    minQtyTimer = setTimeout(applyMinQty, 50);
  }

  function initMinQty() {
    applyMinQty();
    enforceCartMin();
    new MutationObserver(scheduleApply).observe(document.body, { childList: true, subtree: true });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(enforceCartMin, 300); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMinQty);
  } else {
    initMinQty();
  }
})();
